import BaseValidator      from '@/lib/data/validator/BaseValidator'
import ValidatorTypesEnum from '@/lib/data/validator/ValidatorTypesEnum'

export default class ForgotPasswordValidator extends BaseValidator {
  validatorRules = {
    Email: {
      required: true,
      maxLen  : 96,
      type    : ValidatorTypesEnum.Email
    }
  }

  validatorMessages = {
    el: {},
    en: {}
  }

  constructor (data = {}) {
    super(data)
  }
}
